// One outside-click / Escape dismiss hook (O4, docs/design/CODE_AUDIT_2026-07.md) — replaces six
// hand-rolled copies of the same document-mousedown effect. Returns a ref for the container; a
// mousedown outside it (or, with {escape}, an Escape keypress) calls onClose. {enabled} gates the
// listener (pass the open state so a closed popover isn't listening); {capture} uses the capture
// phase (needed when the trigger stops propagation). onClose may be an inline closure — it's read
// through a ref so the document listener isn't re-subscribed on every render.
import { useEffect, useRef } from "react";

export function useClickOutside(onClose, { enabled = true, escape = false, capture = false } = {}) {
  const ref = useRef(null);
  const cb = useRef(onClose);
  cb.current = onClose;
  useEffect(() => {
    if (!enabled) return undefined;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) cb.current(); };
    const onKey = (e) => { if (e.key === "Escape") { e.stopPropagation(); cb.current(); } };
    document.addEventListener("mousedown", onDoc, capture);
    if (escape) document.addEventListener("keydown", onKey, capture);
    return () => {
      document.removeEventListener("mousedown", onDoc, capture);
      if (escape) document.removeEventListener("keydown", onKey, capture);
    };
  }, [enabled, escape, capture]);
  return ref;
}
